$(document).ready(function() {
  var pickupLabel = "BESTELLING OPHALEN"; // the text of the label
  var buttonArea = $('#cart_form .additional-checkout-buttons'); // where to insert the option
  var pickupVariantId = 43764850630; // the variant ID of the local pickup product

  Shopify.getCart(function(cart) {
    var inCart = false;
    $.each(cart.items, function(index, item) {
      if (item.variant_id == pickupVariantId) {
        inCart = true;
        return false;
      }
    });
    buttonArea.append('<div style="width: 100%;max-width: 100%;background: #000000;border: none;"><label for="local-pickup" style="text-align: center;font-weight: 400;font-size: 13px;text-decoration: none;cursor: pointer;margin-bottom: 20px;line-height: normal;padding: 10px 0;color: #ffffff;text-transform: uppercase;"><input id="local-pickup" type="checkbox"' + (inCart ? ' checked' : '') + ' /> ' + pickupLabel + '</label></div>');
  });

  buttonArea.on('change', '#local-pickup', function() {
    if ($(this).is(':checked')) {
      Shopify.addItem(pickupVariantId, 1, function(item) {
        location.reload();
      });
    } else {
      Shopify.changeItem(pickupVariantId, 0, function(cart) {
        location.reload();
      });
    }
  });

});
